export default __webpack_public_path__ + "static/layout-dont-light-da7a95e92934c7551cfe51a65046b74250ab79b0280dc8783cfe58cabc217551.png";